'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var utils_env_isTestEnv_isTestEnv = require('../isTestEnv/isTestEnv.js');

var isBrowserEnv = typeof window !== 'undefined' && !utils_env_isTestEnv_isTestEnv.isTestEnv;

exports.isBrowserEnv = isBrowserEnv;
//# sourceMappingURL=isBrowserEnv.js.map
